import { Box } from '@global-engineering-shared/gweb-material-ui';

import SearchOptionLabel from 'components/Header/components/SearchBar/SearchOption/components/SearchOptionLabel';
import SearchOptionTitle from 'components/Header/components/SearchBar/SearchOption/components/SearchOptionTitle';
import { searchOptionLabelElements } from 'components/Header/components/SearchBar/SearchOption/utils/searchOptionLabelElements';
import { IFormattedSearch } from 'components/Header/index';

import useStyles from './SearchOption.styles';

type SearchOptionProps = {
  option: IFormattedSearch;
  inputValue: string;
};

const SearchOption = ({ option, inputValue }: SearchOptionProps) => {
  const classes = useStyles();
  const elements = searchOptionLabelElements(option);

  return (
    <Box className={classes.root}>
      <SearchOptionTitle option={option} inputValue={inputValue} />
      <SearchOptionLabel elements={elements} inputValue={inputValue} />
    </Box>
  );
};

export default SearchOption;
